import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import clsx from "clsx";
import { Row, Col } from "antd";
import customStyles from "../../../../../../assets/styles/customStyles";
import {
    currencyFormat, groupBy, overAllCalculation, removeCommaString,
    calculateCGSTTotal, calculateSGSTTotal, calculateIGSTTotal, calculateGSTTotal
} from "../../../../../../helpers/utilities";
import { useSelector } from "react-redux";


export const SalesLines = React.forwardRef((props, ref) => {
    const { preview, list, details, businessDetails } = props;
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const [gstGroup, setGstGroup] = useState([]);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const lineRef = useRef('');
    const gstRef = useRef('');
    const totalRef = useRef('');

    const checkTaxType = (details) => {
        return details?.state?.isUtgst ? 'UTGST' : 'SGST'
    }

    useEffect(() => {
        setGstGroup(groupBy(list ? list.filter(function (el) { return el.includeGst === true }) : [], 'productGstId'));
        setTotalDiscount(list ? parseFloat(list.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.discountAmount || 0), 0)) + parseFloat(list.reduce((a, v) => a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100), 0)) : 0);
    }, [list]);

    useImperativeHandle(ref, () => ({
        checkHeight(data, format = 'format1') {
            let l = lineRef.current.offsetHeight;
            let g = gstRef.current ? gstRef.current.offsetHeight : 0;
            let t = l + g;
            if (data === 'none') {
                if (gstRef.current) {
                    gstRef.current.style.marginTop = '0px';
                }
                totalRef.current.style.marginTop = '0px';
            } else {
                if (t > 500 && t < 760) {
                    totalRef.current.style.marginTop = (770 - t) + 'px';
                }
            }
        }
    }))

    const classes = customStyles();
    return (
        <>
            <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading)}>Purchase Lines</div>
            <Row className={clsx(classes.bill, classes.margin20t, classes.viewPrint, classes.justifyContentSpaceBetween)}>
                <Col span={2}><h6>L. No.</h6></Col>
                <Col span={totalDiscount > 0 ? ((details.includeGst || preview) ? 4 : 8) : ((details.includeGst || preview) ? 5 : 10)}><h6>Description</h6></Col>
                {
                    (details.includeGst || preview) && <Col span={totalDiscount > 0 ? 2 : 3}><h6>HSN | SAC</h6></Col>
                }
                <Col span={2} ><h6 style={{ textAlign: "right", paddingRight: 10, }}>Quantity</h6></Col>
                {
                    parameterDetails?.purchaseOrderUnit && <Col span={2} ><h6>Unit</h6></Col>
                }
                <Col span={3} className={clsx(classes.textAlignRight)}><h6>Unit Price</h6></Col>
                {
                    totalDiscount > 0 && <Col span={2} className={clsx(classes.textAlignRight)}><h6>Discount</h6></Col>
                }
                <Col span={3} className={clsx(classes.textAlignRight)}><h6>Line Amount</h6></Col>
                {
                    parameterDetails?.purchaseOrderMrp && <Col span={2} className={clsx(classes.textAlignRight)}><h6>MRP</h6></Col>
                }
                {
                    (details.includeGst || preview) && <Col span={2} className={clsx(classes.textAlignRight)}><h6>GST(%)</h6></Col>
                }
            </Row>
            {
                preview ?
                    <>
                        {(() => {
                            let td = [];
                            for (let i = 1; i <= 6; i++) {
                                td.push(<Row className={clsx(classes.bill, classes.justifyContentSpaceBetween)}>
                                    <Col span={2}><p><span className={clsx(classes.greyBg)} style={{ width: "15px" }}></span></p></Col>
                                    <Col span={4}><p><span className={clsx(classes.greyBg, classes.mediumWidth)}></span></p></Col>
                                    <Col span={4}><p><span className={clsx(classes.greyBg, classes.mediumWidth)}></span></p></Col>
                                    <Col span={3}><p><div className={clsx(classes.col_2, classes.disInline)}><span className={clsx(classes.greyBg)} style={{ width: "40px" }}></span></div><div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}><span className={clsx(classes.greyBg)} style={{ width: "40px" }}></span></div></p></Col>
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} style={{ width: "70px" }}></span></p></Col>
                                    {
                                        parameterDetails?.purchaseOrderMrp && <Col span={2} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} style={{ width: "70px" }}></span></p></Col>
                                    }
                                    <Col span={2} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} style={{ width: "70px" }}></span></p></Col>
                                </Row>);
                            }
                            return td;
                        })()}
                    </>
                    : <div ref={lineRef}>
                        {
                            list && list?.length > 0 ? list?.map((data, i) => (
                                <Row className={clsx(classes.bill, classes.viewPrint, 'no-break', classes.justifyContentSpaceBetween)} key={i}>
                                    <Col span={2}><p>{(i + 1)}</p></Col>
                                    <Col span={totalDiscount > 0 ? (details.includeGst ? 4 : 8) : (details.includeGst ? 5 : 10)}><p style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}>{data.description ? data.description : '---'}</p></Col>
                                    {
                                        details.includeGst && <Col span={totalDiscount > 0 ? 2 : 3}><p>{data?.hsn?.hsnCode || '---'}</p></Col>
                                    }
                                    <Col span={2} className={classes.textAlignRight} style={{ paddingRight: 10 }}><p className={clsx(classes.disInline)}>{data.quantity ? data.quantity : '---'}</p></Col>
                                    {
                                        parameterDetails?.purchaseOrderUnit && <Col span={2}><p className={clsx(classes.disInline)}>{data?.unit?.name || '---'}</p></Col>
                                    }
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p> {`${data.pricePerUnit ? currencyFormat(data.pricePerUnit) : '---'}`}</p></Col>
                                    {
                                        totalDiscount > 0 && <Col span={2} className={clsx(classes.textAlignRight)}><p>{`${(data.discountAmount || data.discountPercent) ?
                                            (data.quantity < 0 ?
                                                currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))) :
                                                currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))))
                                            : currencyFormat(0)}`}</p></Col>
                                    }
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p>{`${data.amount ? currencyFormat(data.amount) : '---'}`}</p></Col>
                                    {
                                        parameterDetails?.purchaseOrderMrp && <Col span={2} className={clsx(classes.textAlignRight)}><p>{currencyFormat(data?.maxRetailPrice || 0)}</p></Col>
                                    }
                                    {
                                        details.includeGst && <Col span={2} className={clsx(classes.textAlignRight)}><p>{data?.includeGst ? (data?.productGst ? data?.productGst?.percentage : '---') : '---'}</p></Col>
                                    }
                                </Row>
                            )) : <Row className={clsx(classes.bill, classes.viewPrint)}>
                                <Col span={24} className={classes.textAlignCenter}><p>No lines found</p></Col></Row>
                        }
                    </div>
            }
            {
                preview ?
                    <div className={clsx(classes.downloadgstDetails, 'no-break')}>
                        <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading, classes.margin20t)}>GST Details</div>
                        <Row className={clsx(classes.bill, classes.margin20t)}>
                            <Col span={5}><h6>Line Reference</h6></Col>
                            <Col span={3}><h6>GST Tax (%)</h6></Col>
                            <Col span={4} className={clsx(classes.textAlignRight)}><h6>CGST</h6></Col>
                            <Col span={4} className={clsx(classes.textAlignRight)}><h6>SGST</h6></Col>
                            <Col span={4} className={clsx(classes.textAlignRight)}><h6>IGST</h6></Col>
                            <Col span={4} className={clsx(classes.textAlignRight)}><h6>GST Amount</h6></Col>
                        </Row>
                        {(() => {
                            let td = [];
                            for (let i = 1; i <= 2; i++) {
                                td.push(<Row className={clsx(classes.bill)}>
                                    <Col span={5}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={3}><p><span className={clsx(classes.greyBg, classes.smallWidth)}></span></p></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                </Row>);
                            }
                            return td;
                        })()}
                    </div>
                    : <>
                        {
                            details.includeGst && gstGroup && Object.keys(gstGroup).length > 0 &&
                            <div ref={gstRef} className={clsx(classes.downloadgstDetails, 'no-break')}>
                                <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading, classes.margin20t)}>GST Details</div>
                                <Row className={clsx(classes.bill, classes.margin20t)}>
                                    <Col span={5}><h6>Line Reference</h6></Col>
                                    <Col span={3}><h6>GST Tax (%)</h6></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><h6>CGST</h6></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><h6>{checkTaxType(businessDetails || details?.business)}</h6></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><h6>IGST</h6></Col>
                                    <Col span={4} className={clsx(classes.textAlignRight)}><h6>GST Amount</h6></Col>
                                </Row>
                                {
                                    gstGroup && Object.keys(gstGroup).length > 0 ? Object?.entries(gstGroup)?.map(([key, value]) => (
                                        <Row className={clsx(classes.bill)} key={key}>
                                            <Col span={5}><p className={classes.padding10R}>{removeCommaString(value)}</p></Col>
                                            <Col span={3}><p>{value[0].igstPercentage ? value[0].igstPercentage : (value[0].cgstPercentage + value[0].sgstPercentage)} </p></Col>
                                            <Col span={4} className={clsx(classes.textAlignRight)}><p> {`${currencyFormat(value.reduce((a, v) => a = a + v.cgst, 0))}`}</p></Col>
                                            <Col span={4} className={clsx(classes.textAlignRight)}><p>{`${currencyFormat(value.reduce((a, v) => a = a + v.sgst, 0))}`}</p></Col>
                                            <Col span={4} className={clsx(classes.textAlignRight)}><p>{`${currencyFormat(value.reduce((a, v) => a = a + v.igst, 0))}`}</p></Col>
                                            <Col span={4} className={clsx(classes.textAlignRight)}><p>{`${currencyFormat(value.reduce((a, v) => a = a + v.gstAmount, 0))}`}</p></Col>
                                        </Row>
                                    )) : <Row className={clsx(classes.bill, classes.textAlignCenter)}><Col span={24}><p> No result found</p></Col></Row>
                                }
                            </div>
                        }
                    </>
            }
            <div ref={totalRef} className={clsx(classes.totalsection, 'no-break')}>
                <Row align={details.includeGst && gstGroup ? '' : 'bottom'} gutter={12} className={clsx(classes.totalsection)} style={{ marginTop: 20 }}>
                    <Col span={7} className={clsx(classes.dispalyIF)}>
                        <div className={clsx(classes.totalsectiondetails)}>
                            {/* {
                                preview ? '' :
                                    <>
                                        {
                                            details?.business ?
                                                <> {
                                                    details?.business?.businessBankDetails?.businessPaymentDetails && details?.business?.businessBankDetails?.businessPaymentDetails?.length > 0 &&
                                                    <>
                                                        <p className={clsx(classes.marginBottom10)} style={{ fontFamily: '"RobotoMedium", "Roboto"', fontWeight: 500 }}>Payment Details:</p>
                                                        <p>Bank Name: {details?.business?.businessBankDetails?.businessPaymentDetails[0]?.bank_name}</p>
                                                        <p>Branch: {details?.business?.businessBankDetails?.businessPaymentDetails[0]?.branch_name}</p>
                                                        <p>IFSC Code: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{details?.business?.businessBankDetails?.businessPaymentDetails[0]?.ifsc_code}</b></p>
                                                        <p className={clsx(classes.marginBottom10)}>A/C Number: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{details?.business?.businessBankDetails?.businessPaymentDetails[0]?.account_number}</b></p>
                                                        {
                                                            details?.business?.businessBankDetails?.wallet_id && details?.business?.businessBankDetails?.walletDetails?.length > 0 &&
                                                            <p>{details?.business?.businessBankDetails?.walletDetails[0]?.name}: {details?.business?.businessBankDetails?.wallet_id}</p>
                                                        }
                                                    </>
                                                }
                                                </> : <> {
                                                    businessDetails?.paymentDetails?.length > 0 &&
                                                    <>
                                                        <p className={clsx(classes.marginBottom10)} style={{ fontFamily: '"RobotoMedium", "Roboto"', fontWeight: 500 }}>Payment Details:</p>
                                                        <p>Bank Name: {businessDetails?.paymentDetails[0]?.bank_name}</p>
                                                        <p>Branch: {businessDetails?.paymentDetails[0]?.branch_name}</p>
                                                        <p>IFSC Code: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{businessDetails?.paymentDetails[0]?.ifsc_code}</b></p>
                                                        <p className={clsx(classes.marginBottom10)}>A/C Number: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{businessDetails?.paymentDetails[0]?.account_number}</b></p>
                                                        {
                                                            businessDetails?.paymentDigitalWalletDetails.length > 0 && businessDetails?.paymentDigitalWalletDetails[0]
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.wallet_id
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails?.length > 0
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails[0]
                                                            && <p>{businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails[0]?.name}:
                                                                {businessDetails?.paymentDigitalWalletDetails[0]?.wallet_id}</p>
                                                        }
                                                    </>
                                                }
                                                </>
                                        }
                                    </>
                            } */}
                            <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading, classes.textAlignRight, classes.authorizedSign)}>Authorized Signatory</div>
                        </div>
                    </Col>
                    <Col span={17}>
                        {
                            preview ?
                                <div className={clsx(classes.totalsectionamount, classes.padding15)}>
                                    <div className={clsx(classes.textAlignRight, classes.col_28, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateCGSTTotal(gstGroup) : 0.00}`}</p></div>
                                    <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateSGSTTotal(gstGroup) : 0.00}`}</p></div>
                                    <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateIGSTTotal(gstGroup) : 0.00}`}</p></div>
                                    <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateGSTTotal(gstGroup) : 0.00}`}</p></div>
                                </div>
                                :
                                <>
                                    {
                                        details.includeGst && gstGroup && Object.keys(gstGroup).length > 0 &&
                                        <div className={clsx(classes.totalsectionamount, classes.padding15)}>
                                            <div className={clsx(classes.textAlignRight, classes.col_28, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateCGSTTotal(gstGroup) : 0.00}`}</p></div>
                                            <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateSGSTTotal(gstGroup) : 0.00}`}</p></div>
                                            <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateIGSTTotal(gstGroup) : 0.00}`}</p></div>
                                            <div className={clsx(classes.textAlignRight, classes.col_24, classes.disInline)}><p>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateGSTTotal(gstGroup) : 0.00}`}</p></div>
                                        </div>
                                    }
                                </>
                        }
                        {
                            preview ? <Row gutter={10} className={clsx(classes.margin10tb, classes.totalsectiontaxamount)}>
                                <Col span={12}>
                                    <div className={clsx(classes.totalsectionamount)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Total GST</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateGSTTotal(gstGroup) : 0.00}`}</div>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className={clsx(classes.totalsectionamount)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Taxable Amount</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(list ? list.reduce((a, v) => a = a + v.amount, 0) : 0)}`}</div>
                                    </div>
                                </Col>
                            </Row> :
                                <>
                                    {
                                        details.includeGst && gstGroup && Object.keys(gstGroup).length > 0 &&
                                        <Row gutter={10} className={clsx(classes.margin10tb, classes.totalsectiontaxamount)}>
                                            <Col span={12}>
                                                <div className={clsx(classes.totalsectionamount)}>
                                                    <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Total GST</div>
                                                    <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateGSTTotal(gstGroup) : 0.00}`}</div>
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className={clsx(classes.totalsectionamount)}>
                                                    <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Taxable Amount</div>
                                                    <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(calculateGrandTotal(list, details)?.netAmount) || 0}`}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </>
                        }

                        <div className={clsx(classes.totalsectionamount, classes.totalsectiontaxamount, classes.pad1520)}>
                            {
                                details?.roundOffAmount !== 0 && <>
                                    <div className={clsx(classes.col_2, classes.disInline)}></div>
                                    <div className={clsx(classes.col_2, classes.disInline)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)} style={{ paddingLeft: 55, fontSize: '14px' }}>Round Off</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)} style={{ fontSize: '14px' }}>{details?.roundOffAmount}</div>
                                    </div>
                                </>
                            }
                            <div className={clsx(classes.col_2, classes.disInline)}></div>
                            <div className={clsx(classes.col_2, classes.disInline)}>
                                <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)} style={{ paddingLeft: 20 }}>Grand Total</div>
                                <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount || 0)}`}</div>
                            </div>
                            <div className={classes.textAlignRight} style={{ lineHeight: 1, marginTop: 7 }}>{overAllCalculation(details?.invoiceAmount || 0)}</div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.margin15t, classes.textclblack, classes.termsandcondition, 'no-break')}>
                {
                    preview ? '' :
                        <>
                            {
                                details?.comments && <pre> {details?.comments}</pre>
                            }
                        </>
                }
            </div>
        </>
    )
});

const calculateGrandTotal = (list, details) => {
    let data = {};
    if (list && list.length > 0) {
        let total = list && list.reduce((a, v) => a = a + v.amount, 0);
        let totalNet = list && list.reduce((a, v) => a = a + (v.includeGst ? v.amount : 0), 0);
        let discount = list && list.reduce((a, v) => a = parseFloat(a) + parseFloat(v.discountAmount), 0);
        let discountPercent = list && list.reduce((a, v) => {
            if (v.amount < 0) {
                a = parseFloat(a) - parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100)
            } else {
                a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100)
            }
            return a;
        }, 0);
        let gst = list && list.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0);
        if (details?.priceIncludesTax) {
            data['invoiceAmount'] = total;
            data['netAmount'] = totalNet - gst;
        } else {
            data['invoiceAmount'] = total + gst;
            data['netAmount'] = totalNet;
        }
        data['totalDiscount'] = discount + discountPercent;
        data['gstAmount'] = gst;
    } else {
        data['invoiceAmount'] = 0;
        data['totalDiscount'] = parseFloat(0.00);
        data['gstAmount'] = parseFloat(0.00);
        data['netAmount'] = parseFloat(0.00);
    }

    return data;
}

export const SalesLinesQuote = React.forwardRef((props, ref) => {
    const { preview, list, details } = props;
    // const [gstGroup, setGstGroup] = useState([]);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const lineRef = useRef('');
    const gstRef = useRef('');
    const totalRef = useRef('');

    useImperativeHandle(ref, () => ({
        checkHeight(data, format = 'format1') {
            let l = lineRef.current.offsetHeight;
            let g = gstRef.current ? gstRef.current.offsetHeight : 0;
            let t = l + g;
            if (data === 'none') {
                if (gstRef.current) {
                    gstRef.current.style.marginTop = '0px';
                }
                totalRef.current.style.marginTop = '0px';
            } else {
                if (t > 500 && t < 760) {
                    totalRef.current.style.marginTop = (770 - t) + 'px';
                }
            }
        }
    }))

    useEffect(() => {
        // setGstGroup(groupBy(list ? list.filter(function (el) { return el.includeGst === true }) : [], 'productGstId'));
        setTotalDiscount(list ? parseFloat(list.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.discountAmount || 0), 0)) + parseFloat(list.reduce((a, v) => a = parseFloat(a) + parseFloat(((v.quantity * v.pricePerUnit) * v.discountPercent) / 100), 0)) : 0);
    }, [list]);

    const classes = customStyles();
    return (
        <>
            <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading)}>Purchase Lines</div>
            <Row className={clsx(classes.bill, classes.margin20t, classes.viewPrint)}>
                <Col span={2}><h6>L. No.</h6></Col>
                <Col span={totalDiscount > 0 ? ((preview) ? 5 : 10) : ((preview) ? 6 : 11)}><h6>Description</h6></Col>
                {
                    preview && <Col span={totalDiscount > 0 ? 3 : 4}><h6>HSN | SAC</h6></Col>
                }
                <Col span={2} ><h6 style={{ textAlign: "right", paddingRight: 10, }}>Quantity</h6></Col>
                <Col span={2} ><h6>Unit</h6></Col>
                <Col span={3} className={clsx(classes.textAlignRight)}><h6>Unit Price</h6></Col>
                {
                    totalDiscount > 0 && <Col span={2} className={clsx(classes.textAlignRight)}><h6>Discount</h6></Col>
                }
                <Col span={3} className={clsx(classes.textAlignRight)}><h6>Line Amount</h6></Col>

            </Row>
            {
                preview ?
                    <>
                        {(() => {
                            let td = [];
                            for (let i = 1; i <= 6; i++) {
                                td.push(<Row className={clsx(classes.bill)}>
                                    <Col span={2}><p><span className={clsx(classes.greyBg)} style={{ width: "15px" }}></span></p></Col>
                                    <Col span={6}><p><span className={clsx(classes.greyBg, classes.mediumWidth)}></span></p></Col>
                                    <Col span={4}><p><span className={clsx(classes.greyBg, classes.mediumWidth)}></span></p></Col>
                                    <Col span={3}><p><div className={clsx(classes.col_2, classes.disInline)}><span className={clsx(classes.greyBg)} style={{ width: "40px" }}></span></div><div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}><span className={clsx(classes.greyBg)} style={{ width: "40px" }}></span></div></p></Col>
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} ></span></p></Col>
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} style={{ width: "70px" }}></span></p></Col>
                                    <Col span={2} className={clsx(classes.textAlignRight)}><p><span className={clsx(classes.greyBg, classes.smallWidth)} style={{ width: "70px" }}></span></p></Col>

                                </Row>);
                            }
                            return td;
                        })()}
                    </>
                    : <div ref={lineRef}>
                        {
                            list && list?.length > 0 ? list?.map((data, i) => (
                                <Row className={clsx(classes.bill, classes.viewPrint)} key={i}>
                                    <Col span={2}><p>{data?.lineNumber || '---'}</p></Col>
                                    <Col span={totalDiscount > 0 ? 10 : 11}><p>{data.description ? data.description : '---'}</p></Col>
                                    <Col span={2} className={classes.textAlignRight} style={{ paddingRight: 10 }}><p className={clsx(classes.disInline)}>{data.quantity ? data.quantity : '---'}</p></Col>
                                    <Col span={2}><p className={clsx(classes.disInline)}>{data?.unit?.name || '---'}</p></Col>
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p> {`${data.pricePerUnit ? currencyFormat(data.pricePerUnit) : '---'}`}</p></Col>
                                    {
                                        totalDiscount > 0 && <Col span={2} className={clsx(classes.textAlignRight)}><p>{`${(data.discountAmount || data.discountPercent) ?
                                            (data.quantity < 0 ?
                                                currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))) :
                                                currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))))
                                            : currencyFormat(0)}`}</p></Col>
                                    }
                                    <Col span={3} className={clsx(classes.textAlignRight)}><p>{`${data.amount ? currencyFormat(data.amount) : '---'}`}</p></Col>
                                </Row>
                            )) : <Row className={clsx(classes.bill, classes.viewPrint)}>
                                <Col span={24} className={classes.textAlignCenter}><p>No lines found</p></Col></Row>
                        }
                    </div>
            }

            <div ref={totalRef} className={clsx(classes.totalsection, classes.pageBreak)}>
                <Row align={'bottom'} gutter={12} className={clsx(classes.totalsection)} style={{ marginTop: 20 }}>
                    <Col span={7} className={clsx(classes.dispalyIF)}>
                        <div className={clsx(classes.totalsectiondetails)}>
                            {/* {
                                preview ? '' :
                                    <>
                                        {
                                            details?.business ?
                                                <> {
                                                    details?.business?.businessBankDetails?.businessPaymentDetails && details?.business?.businessBankDetails?.businessPaymentDetails?.length > 0 &&
                                                    <>
                                                        <p className={clsx(classes.marginBottom10)} style={{ fontFamily: '"RobotoMedium", "Roboto"', fontWeight: 500 }}>Payment Details:</p>
                                                        <p>Bank Name: {details?.business?.businessBankDetails?.businessPaymentDetails[0]?.bank_name}</p>
                                                        <p>Branch: {details?.business?.businessBankDetails?.businessPaymentDetails[0]?.branch_name}</p>
                                                        <p>IFSC Code: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{details?.business?.businessBankDetails?.businessPaymentDetails[0]?.ifsc_code}</b></p>
                                                        <p className={clsx(classes.marginBottom10)}>A/C Number: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{details?.business?.businessBankDetails?.businessPaymentDetails[0]?.account_number}</b></p>
                                                        {
                                                            details?.business?.businessBankDetails?.wallet_id && details?.business?.businessBankDetails?.walletDetails?.length > 0 &&
                                                            <p>{details?.business?.businessBankDetails?.walletDetails[0]?.name}: {details?.business?.businessBankDetails?.wallet_id}</p>
                                                        }
                                                    </>
                                                }
                                                </> : <> {
                                                    businessDetails?.paymentDetails?.length > 0 &&
                                                    <>
                                                        <p className={clsx(classes.marginBottom10)} style={{ fontFamily: '"RobotoMedium", "Roboto"', fontWeight: 500 }}>Payment Details:</p>
                                                        <p>Bank Name: {businessDetails?.paymentDetails[0]?.bank_name}</p>
                                                        <p>Branch: {businessDetails?.paymentDetails[0]?.branch_name}</p>
                                                        <p>IFSC Code: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{businessDetails?.paymentDetails[0]?.ifsc_code}</b></p>
                                                        <p className={clsx(classes.marginBottom10)}>A/C Number: <b style={{ fontFamily: '"RobotoMedium", "Roboto"' }}>{businessDetails?.paymentDetails[0]?.account_number}</b></p>
                                                        {
                                                            businessDetails?.paymentDigitalWalletDetails.length > 0 && businessDetails?.paymentDigitalWalletDetails[0]
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.wallet_id
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails?.length > 0
                                                            && businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails[0]
                                                            && <p>{businessDetails?.paymentDigitalWalletDetails[0]?.walletDetails[0]?.name}:
                                                                {businessDetails?.paymentDigitalWalletDetails[0]?.wallet_id}</p>
                                                        }
                                                    </>
                                                }
                                                </>
                                        }
                                    </>
                            } */}
                            <div style={{ fontFamily: '"RobotoMedium", "Roboto"' }} className={clsx(classes.downloadsHeading, classes.textAlignRight, classes.authorizedSign)}>Authorized Signatory</div>
                        </div>
                    </Col>
                    <Col span={17}>
                        {
                            preview ? <Row gutter={10} className={clsx(classes.margin10tb, classes.totalsectiontaxamount)}>
                                <Col span={12}>
                                    {/* <div className={clsx(classes.totalsectionamount)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Total GST</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${gstGroup ? calculateGSTTotal(gstGroup) : 0.00}`}</div>
                                    </div> */}
                                </Col>
                                <Col span={12}>
                                    {/* <div className={clsx(classes.totalsectionamount)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)}>Taxable Amount</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.selfBillItems ? details?.selfBillItems.reduce((a, v) => a = a + v.amount, 0) : 0)}`}</div>
                                    </div> */}
                                </Col>
                            </Row> :
                                ''
                        }
                        <div className={clsx(classes.totalsectionamount, classes.totalsectiontaxamount, classes.pad1520)}>
                            {
                                details?.roundOffAmount !== 0 && <>
                                    <div className={clsx(classes.col_2, classes.disInline)}></div>
                                    <div className={clsx(classes.col_2, classes.disInline)}>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)} style={{ paddingLeft: 55, fontSize: '14px' }}>Round Off</div>
                                        <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)} style={{ fontSize: '14px' }}>{details?.roundOffAmount}</div>
                                    </div>
                                </>
                            }
                            <div className={clsx(classes.col_2, classes.disInline)}></div>
                            <div className={clsx(classes.col_2, classes.disInline)}>
                                <div className={clsx(classes.col_2, classes.disInline, classes.blueHeader)} style={{ paddingLeft: 20 }}>Grand Total</div>
                                <div className={clsx(classes.col_2, classes.disInline, classes.textAlignRight)}>{preview ? <span className={clsx(classes.greyBg, classes.smallWidth)}></span> : `${currencyFormat(details?.invoiceAmount || 0)}`}</div>
                            </div>
                            <div className={classes.textAlignRight} style={{ lineHeight: 1.5, marginTop: 7 }}>{overAllCalculation(details?.invoiceAmount || 0)}</div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.margin15t, classes.textclblack, classes.termsandcondition, classes.pageBreak)}>
                {
                    preview ? '' :
                        <>
                            {
                                details?.comments && <pre> {details?.comments}</pre>
                            }
                        </>
                }
            </div>
        </>
    )
});




